export { BarcodeModule } from './barcode.module';
